const tabModule = document.querySelector('.tab-module');

if (tabModule) {
  tabModule.querySelectorAll('.tab__link').forEach((link, index) => {
    link.addEventListener('click', () => {
      tabModule.querySelectorAll('.tab__link').forEach((el) => el.classList.remove('is-active'));
      link.classList.add('is-active');

      tabModule.querySelectorAll('.tab-module__block').forEach((block, blockIndex) => {
        block.classList.toggle('is-active', blockIndex === index);
      });
    });
  });
}
